/**
 * Conditional logger — only logs in development mode.
 * In production builds, all calls become no-ops.
 */

const isDev = typeof import.meta !== 'undefined'
  ? (import.meta as any).env?.DEV === true
  : (typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production');

function noop(..._args: unknown[]): void {}

export const logger = {
  log: isDev ? console.log.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: console.error.bind(console), // errors always logged
  info: isDev ? console.info.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
};

export default logger;
